const { getElements } = window.BAO.Utils;

class QuickAddDrawer extends window.BAO.CustomElement() {
	connectedCallback() {
		super.connectedCallback();
		this.triggerButton = this.externalEls?.trigger?.element;
		this.drawerSectionId = 'quick-add-drawer';
		this.drawerContent = this.els?.contentWrapper;

		this.openDrawer = this.openDrawer.bind(this)
	}

	disconnectedCallback() {
    super.disconnectedCallback();
    this.listeners.removeAll();
}

	setupListeners() {
		super.setupListeners();

		this.listeners.add(document, 'click', (evt) => this.openDrawer(evt)),
			this.listeners.add(this.els?.closeTrigger?.element, 'click', (evt) =>
				this.closeDrawer(),
			);

		this.listeners.add(document, 'content:replaced', () => this.closeDrawer());

		this.listeners.add(document, 'cart:added', () => this.closeDrawer())
	}

	closeDrawer() {
		this.inert = true;
		this.classList.remove('quick-add--opened');
		document.body.classList.remove('is-quick-add-opened');
		this.triggerButton.focus();
	}

	async openDrawer(evt) {
		if (!evt.target.closest(this.externalEls?.trigger?.selector)) {
			return;
		}

		this.inert = false;
		this.drawerContent.element.focus();

		const productHandle = evt.target.closest('button')?.dataset.productHandle;

		if (!productHandle) {
			console.error('Product handle not found in event target.');
			return;
		}

		try {
			const quickAddHtml = await this.fetchProductSection(productHandle);
			this.drawerContent.element.innerHTML = quickAddHtml;

			// Event accessed in wishlist.js
			this.currentVariant = JSON.parse(this.drawerContent.element?.querySelector(this.els?.variantData?.selector).innerText)

			this.drawerOpenEvent = new CustomEvent('quick-add-drawer:opened', {
				detail: {
					variant: this.currentVariant
				}
			})

			document.dispatchEvent(this.drawerOpenEvent)

			this.classList.add('quick-add--opened');
			document.body.classList.add('is-quick-add-opened');

		} catch (error) {
			console.error('Failed to open drawer:', error);
		}
	}

	async fetchProductSection(productHandle) {
		const fetchUrl = `${window.routes.rootUrl}products/${productHandle}?section_id=${this.drawerSectionId}`;

		try {
			const response = await fetch(fetchUrl);
			const responseText = await response.text();

			const parser = new DOMParser();
			const parsedHtml = parser.parseFromString(responseText, 'text/html');
			const sectionContainer = parsedHtml.querySelector(
				this.drawerContent.selector,
			);

			if (!sectionContainer) {
				throw new Error('Section container not found in fetched HTML.');
			}

			return sectionContainer.innerHTML;
		} catch (error) {
			console.error('Error fetching product section:', error);
			throw error;
		}
	}
}

if (!customElements.get('quick-add-drawer')) {
	customElements.define('quick-add-drawer', QuickAddDrawer);
}
